<section class="topbar">
  <div class="topbar__block block-left">
    <h1 class="topbar__title" *ngIf="!backUrl && !catchBackClick; else titleAsLink">
      {{ mainTitle }}
    </h1>

    <ng-template #titleAsLink>
      <a class="topbar__link" (click)="goBack()"
         [ngClass]="{
            'have-subtext': secondTitle,
            'no-title': !mainTitle && !secondTitle
         }">
        <p class="topbar__link-title text-ellipsis">{{ mainTitle || '' }}</p>
        <p class="topbar__link-subtext text-ellipsis" *ngIf="secondTitle">{{ secondTitle }}</p>
      </a>
    </ng-template>
  </div>
  <div class="topbar__block block-right">
    <ng-content></ng-content>
  </div>
</section>
